import React from 'react'

const sharedTitleStyles = 'text-text-brand-primary uppercase text-bodyS font-bold font-poppins leading-normal'
const sharedValueStyles = 'text-bodyM text-text-dark-900 leading-relaxed font-sans'
const sharedContainerStyles = 'flex-1 flex flex-col gap-12 justify-center bg-secondary-200'
const borderStyles = 'border-r-1 border-grey-100'

function TableSection({ title, value, isLast }: { title: string; value: string; isLast: boolean }) {
  return (
    <div className={`${sharedContainerStyles} ${!isLast ? borderStyles : ''}`}>
      <p className={sharedTitleStyles}>{title}</p>
      <p className={sharedValueStyles}>{value}</p>
    </div>
  )
}

export function OverviewTable({ table }: { table: { _uid: string; title: string; value: string }[] }) {
  return (
    <div className="bg-white rounded-xl p-16 netbook:p-24 text-center netbook:inline netbook:flex-grow max-h-192 netbook:max-w-[432px] netbook:ml-auto">
      <div className="flex flex-wrap gap-16 mb-12 netbook:mb-18">
        {table.slice(0, 2).map((item, index) => (
          <TableSection key={item._uid || index} title={item.title} value={item.value} isLast={index === 1} />
        ))}
      </div>
      {table[2] && (
        <div className="w-full flex flex-col gap-12 justify-center bg-secondary-400 pt-12 border-t-1 border-grey-100">
          <p className={sharedTitleStyles}>{table[2].title}</p>
          <p className={sharedValueStyles}>{table[2].value}</p>
        </div>
      )}
    </div>
  )
}
